import { useCallback } from "react";
import { useBanner } from "../../contexts";
function useGroupCheckbox(group) {
    var _consent_id;
    const banner = useBanner();
    const { id, items, isEssential } = group;
    const { previewCheckboxActiveState, consent, activeAction } = banner;
    const isDisabled = isEssential || activeAction === "history";
    const isChecked = previewCheckboxActiveState || isEssential || !!consent[id];
    const isPartial = !isEssential && ((_consent_id = consent[id]) == null ? void 0 : _consent_id.length) && JSON.stringify(items.map((param)=>{
        let { id } = param;
        return id;
    }).sort()) !== JSON.stringify(consent[id].sort() || []);
    const onToggle = useCallback((checked)=>banner.updateGroupChecked(id, checked), [
        banner,
        id,
        isChecked
    ]);
    return {
        isDisabled,
        isChecked,
        isPartial,
        onToggle
    };
}
export { useGroupCheckbox };
